// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { pick } from '../common/utils';
import styled from '../common/styled';
import * as actions from '../actions';

class Header extends React.Component {
  static height = 50

  componentDidMount() {
    const { history } = this.props;

    this.props.setRoute(history.location.pathname);
    this.props.history.listen((location, action) => {
      this.props.setRoute(history.location.pathname);
    });
  }

  render() {
    const {
      title, left, right, hidden
    } = this.props.header;
    const clickArg = {
      history: this.props.history
    };
    if (hidden) {
      return null;
    }
    return (
      <HeaderWrapper>
        <LeftButton visible={!!left} onClick={() => left && left.onClick(clickArg)}>
          {left && left.node}
        </LeftButton>
        <Title>{title}</Title>
        <RightButton visible={!!right} onClick={() => right && right.onClick(clickArg)}>
          {right && right.node}
        </RightButton>
      </HeaderWrapper>
    );
  }
}

export default connect(
  pick(['route', 'internalStack', 'header']),
  dispatch => bindActionCreators({ ...actions }, dispatch)
)(withRouter(Header));

const HeaderWrapper = styled.View`
  position: fixed;
  z-index: 100;
  top: 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: ${Header.height}px;
  line-height: ${Header.height}px;
  background-color: ${styled.mainColor}
  color: #fff;
  font-size: 18px;
`;

const LeftButton = styled.View`
  margin-right: 15px;
  padding-left: 15px;
  min-width: 60px;
  text-align: left;
  cursor: pointer;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

const RightButton = styled.View`
  margin-left: 15px;
  padding-right: 15px;
  min-width: 60px;
  text-align: right;
  cursor: pointer;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

const Title = styled.Text`
  flex: 1;
  text-align: center;
  font-weight: bold;
`;
